import { ICsvDefinition } from ".";

export const renderCsv = <TItem>(csvDef: ICsvDefinition<TItem>, items: TItem[]): string => {
  let csv = "\uFEFF"; // Prevent encoding issue in Excel https://stackoverflow.com/a/42466254

  // header row
  const columnKeys = Object.keys(csvDef.columns);
  csv += columnKeys.join(",");
  csv += "\n";

  // item rows
  for (const row of items) {
    for (const key of columnKeys) {
      const val = csvDef.columns[key](row);
      let str = val != null ? val : "";
      str = str.replace(/"/g, '""'); // Escape quotes so they don't break multiline strings
      csv += `"${str}",`;
    }
    csv += "\n";
  }

  return csv;
};
